import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Firebase Auth action handler. The custom action URL configured in the
 * Firebase console (Authentication -> Templates) is project-wide, so every
 * email link lands here with `mode` + `oobCode` and is dispatched to the
 * right screen.
 */
const AuthActionScreen = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const oobCode = searchParams.get('oobCode') || '';

  switch (mode) {
    case 'resetPassword':
      return <Navigate to={`/reset-password?oobCode=${encodeURIComponent(oobCode)}`} replace />;
    case 'verifyEmail':
    default:
      return <Navigate to={`/verify-email?oobCode=${encodeURIComponent(oobCode)}`} replace />;
  }
};

export default AuthActionScreen;
